import React, { FC } from 'react';
import styled from 'src/theme';
import {Col, Row, Typography} from "antd";
import {Button} from 'src/components/UI';

// import { useStoreon } from 'storeon/react';

import { usePresenter } from './usePresenter';

export const Result: FC = () => {

  // const { dispatch } = useStoreon()

  const presenter = usePresenter();

  // const handleClickResult = () => {
  //   dispatch('fence/set-modal-is-open', { modalIsOpen: true });
  // }

  return (
    <ResultRowStyled>
      <Col xs={24}>
        <Row justify='end' align="middle" gutter={24}>
          <Col><ResultStyled>Итого: <Typography.Text strong>{presenter.totalPrice} руб *</Typography.Text></ResultStyled></Col>
          <Col>
            <Button
              onClick={presenter.resultHandler}
              style={{ textTransform: 'uppercase' }}
            >
              Расчетная таблица
            </Button>
          </Col>
        </Row>
      </Col>
    </ResultRowStyled>
  );
}

const ResultRowStyled = styled(Row)`
  margin-top: 32px;
  @media screen and ${props => props.theme.media.tablet} {}
  @media screen and ${props => props.theme.media.mobile} {
    margin: 16px 0;
  }
`;

const ResultStyled = styled.div`
  margin: 9px 0;
  font-family: 'Montserrat', sans-serif;
  font-size: 15px;
  @media screen and ${props => props.theme.media.tablet} {}
  @media screen and ${props => props.theme.media.mobile} {}
  span {
    font-size: 17px;
  }
`;
